'use strict';

var ColorPicker = require('./components/Color');

ColorPicker.chrome = require('./components/ChromePicker');
ColorPicker.compact = require('./components/CompactPicker');
ColorPicker.material = require('./components/MaterialPicker');
ColorPicker.photoshop = require('./components/PhotoshopPicker');
ColorPicker.sketch = require('./components/SketchPicker');
ColorPicker.slider = require('./components/SliderPicker');
ColorPicker.swatches = require('./components/SwatchesPicker');

module.exports = ColorPicker;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-color/lib/index.js
 ** module id = 153
 ** module chunks = 0
 **/